import { CardSkeleton } from "./CardSkeleton";
export default CardSkeleton;